/* eslint-disable no-use-before-define */
import React from 'react'
import { $, mediaQueries, arrayFrom, getConfig } from '../twd'
import download from './download'

export default ({selection, clearSelection, invType}) => {

    const barRef = React.useRef()
    React.useEffect(() => {
        let el = $(barRef.current)
        let fn = () => {
            let w = el.parent().width()
                - 30 - (mediaQueries.isNotXs() ? 5 : 0)
            el.width(w)
        }

        fn()
        el.show()
        $(window).resize(fn)

        return () => {
            $(window).off('resize', fn)
        }
    },[selection])

    const [status, setStatus] = React.useState('')

    let arr = arrayFrom(selection)
    if (arr.length===0) return ''

    const isBlue = getConfig('entitlements.ETradeBlue', 'No') === 'Yes'
    return <div
        ref={barRef}
        style={{display:'none'}}
        className="snackbar-fixed vertical-offset-xs snackbar">
    <div className="snackbar-left vertical-offset-xs-xs vertical-offset-sm-clear">
        <span className={isBlue ? 'snackbar-blue-label': ''}>{arr.length} selected</span>
    </div>
    <div className="snackbar-right">
        <button
            data-name="offerings-selection-download-to-csv"
            className={"btn btn-lg vertical-offset-xs-xs vertical-offset-sm-clear btn-primary" + (isBlue ? ' snackbar-blue-btn-action' : '')}
            type="button"
            disabled={status==='DOWNLOADING'}
            onClick={async () => {
                setStatus('DOWNLOADING')
                await download({invType, selection})
                setStatus('')
            }}
        >Download to .csv</button>
        <span
            style={isBlue ? {paddingRight:'5px'} : {}}
            className="text-center">
            <button
                data-name="offerings-selection-cancel"
                className={ isBlue ? 'btn btn-lg vertical-offset-xs-xs vertical-offset-sm-clear btn-primary snackbar-blue-btn-action-alt' : "btn-link" }
                type="button"
                onClick={clearSelection}
            >Cancel</button>
        </span>
    </div>
    </div>

}



// WEBPACK FOOTER //
// ./src/offerings/selection.js